import React from "react";
import AppContent from "../components/AppContent";
// import { AppSidebar } from "../components/index";
import "./layout.scss";
import AppHeader from "../components/AppHeader";
import AppSidebar from "../components/AppSidebar";
import NoteState from "../../context/NOTES/NoteState";

const DefaultLayout = () => {
  return (
    <div>
      <AppSidebar />
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <AppHeader />
        <div className="body flex-grow-1 px-3">
          <NoteState>


          <AppContent />
          </NoteState>
        </div>
        {/* <AppFooter /> */}
      </div>
    </div>
  );
};

export default DefaultLayout;
